<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size - 5"
    viewBox="0 0 12 7"
    fill="none"
    class="icon-down-chevron">
    <path
      class="icon-down-chevron__path"
      d="M6.34605 4.74669L10.3914 0.739924C10.7594 0.375428 11.356 0.375428 11.724 0.739924C12.092 1.10442 12.092 1.69538 11.724 2.05988L7.01238 6.72663C6.64438 7.09112 6.04773 7.09112 5.67973 6.72663L0.968106 2.05988C0.600105 1.69538 0.600105 1.10442 0.968106 0.739924C1.33611 0.375428 1.93275 0.375428 2.30075 0.739924L6.34605 4.74669Z"
      :fill="color" />
    <mask
      id="mask0_1618_24808"
      style="mask-type: luminance"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      :width="size"
      :height="size - 5">
      <path
        class="icon-down-chevron__path"
        d="M6.34605 4.74669L10.3914 0.739924C10.7594 0.375428 11.356 0.375428 11.724 0.739924C12.092 1.10442 12.092 1.69538 11.724 2.05988L7.01238 6.72663C6.64438 7.09112 6.04773 7.09112 5.67973 6.72663L0.968106 2.05988C0.600105 1.69538 0.600105 1.10442 0.968106 0.739924C1.33611 0.375428 1.93275 0.375428 2.30075 0.739924L6.34605 4.74669Z"
        :fill="color" />
    </mask>
  </svg>
</template>

<script setup>
  defineProps({
    size: {
      type: Number,
      default: 15,
    },
    color: {
      type: String,
      default: '#212444',
    },
  });
</script>

<style lang="scss" scoped>
  .icon-down-chevron {
    transition: transform 0.65s ease-in-out;
    .icon-down-chevron__path {
      fill: currentColor;
    }
  }
</style>
